import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';
import {
  Question,
  NextStepBtn,
  PrevStepBtn,
  WithInfoPanel,
} from '../../../common/FormWithSteps';
import { pushGoogleDataLayer } from '../../../common/FormWithSteps/Utilities';

export const StepQuestion = ({
  role,
  active,
  questionId,
  previousStep,
  questions,
  updateActiveStep,
  updateQuestionById,
  goToReviewPlan,
  googleData,
  isValid,
}) => {
  const sendDataToGTM = useGTMDispatch();
  const [visibleInfoPanel, setVisibility] = useState(false);
  const toggleInfoPanel = () => {
    setVisibility((prevState) => !prevState);
  };
  const { dirty, hasError } = questions[questionId];
  const validate = !!(dirty && hasError);
  const handleQuestionChange = (id, updateValue, valueFormatted) => {
    updateQuestionById(
      id,
      updateValue,
      updateValue === '',
      true,
      valueFormatted,
    );
  };
  useEffect(() => {
    pushGoogleDataLayer(googleData);
  }, []);

  return (
    <div className="container-fluid h-100">
      <WithInfoPanel
        visibleInfoPanel={visibleInfoPanel}
        setVisibility={setVisibility}
        heading={questions[questionId].heading}
        content={questions[questionId].content}
        toggleInfoPanel={toggleInfoPanel}
      >
        <Question
          role={role}
          type={questions[questionId].type}
          labelClass="fs-form-q font-weight-bold mb-md-5 text-center"
          inputClass={
            questions[questionId].type === 'number_field'
              ? 'text-question srp-form-input form-control'
              : 'srp-form-input form-control'
          }
          radioWrapper={
            questions[questionId].type === 'radio_condensed'
              ? 'srp-form-toggle'
              : ''
          }
          thousandSeparator
          question={questions[questionId]}
          handleQuestionChange={handleQuestionChange}
          hasInfo={!!questions[questionId].heading}
          toggleInfoPanel={toggleInfoPanel}
        />
        {validate && (
          <p className="text-danger text-center">Question is required</p>
        )}
        {questions[questionId].heading && (
          <p className="text-center mb-lg-auto">
            <button
              type="button"
              className="srp-button srp-button__link mx-auto"
              onClick={() => {
                toggleInfoPanel();
              }}
            >
              Need clarification?
            </button>
          </p>
        )}
        <p className="text-center">
          <NextStepBtn
            text="Review your plan"
            disabled={!isValid}
            onClick={() => {
              sendDataToGTM({
                event: 'e_toolInteraction',
                eventType: 'progress',
                tool: {
                  name: 'Simply Retirement',
                  stepNumber: '2',
                  stepName: 'review',
                },
              });
              goToReviewPlan();
            }}
          />
        </p>
      </WithInfoPanel>
      <PrevStepBtn
        active={active}
        goTo={previousStep}
        updateActiveStep={updateActiveStep}
      />
    </div>
  );
};

StepQuestion.propTypes = {
  role: PropTypes.string,
  active: PropTypes.bool,
  questionId: PropTypes.string,
  previousStep: PropTypes.string,
  questions: PropTypes.object,
  updateActiveStep: PropTypes.func,
  updateQuestionById: PropTypes.func,
  goToReviewPlan: PropTypes.func,
  googleData: PropTypes.object,
  isValid: PropTypes.bool,
};

export default StepQuestion;
